<template>
  <div>
    <a-button
      :type="button.type"
      :size="button.size"
      :loading="isUploading"
      :style="button.style"
      @click="input.click()"
    >
      <template #icon>
        <slot name="icon" />
      </template>
      <template v-if="!$slots.icon">
        <CloudUploadOutlined />
        {{ button.name }}
      </template>
    </a-button>
    <input
      ref="input"
      type="file"
      multiple
      hidden
      @change="upload"
    >
  </div>
</template>

<script>
import { ref } from 'vue'
import { CloudUploadOutlined } from '@ant-design/icons-vue'

import { upload as uploadApi } from '@/api/upload'

export default {
  name: 'Upload',
  components: {
    CloudUploadOutlined
  },
  props: {
    button: {
      type: Object,
      default: () => ({})
    },
    beforeUpload: {
      type: Function,
      default () {
        return true
      }
    }
  },
  emits: [
    'files-uploaded'
  ],
  setup (props, { emit }) {
    const input = ref(null)
    const isUploading = ref(false)

    function reset () {
      input.value.value = ''
      isUploading.value = false
    }

    function upload (e) {
      const files = [...e.target.files]
      if (!props.beforeUpload(files)) {
        reset()
        return
      }

      uploadApi(files).then(uploadedFiles => {
        emit('files-uploaded', uploadedFiles)
        reset()
      })
    }

    return {
      input,
      isUploading,
      upload,
      reset
    }
  }
}
</script>
